import * as React from 'react';
import { IconClose12, TColors } from '@cian/ui-kit';
import classNames from 'clsx';

import * as styles from './MapOnboardingTooltip.css';

export interface IMapOnboardingTooltipProps {
  content: React.ReactNode;
  placement: 'right' | 'bottom';
  onClose: () => void;
}

/**
 * Своя временная реализация тултипов для карты.
 * Сделано, чтобы пофиксить баг с вылезанием тултипа на меню при скролле
 * https://rocketchat.cian.tech/channel/ui-kit?msg=ZtELfN5hpKgRB2Cbf
 */
export const MapOnboardingTooltip: React.FC<IMapOnboardingTooltipProps> = ({ content, placement, onClose }) => {
  const [closeButtonColor, setCloseButtonColor] = React.useState<TColors>('white_40');

  const handleMouseEnterInCloseButton = React.useCallback(() => setCloseButtonColor('white_60'), []);
  const handleMouseLeaveCloseButton = React.useCallback(() => setCloseButtonColor('white_40'), []);

  const handleCloseButtonClick: React.MouseEventHandler<HTMLDivElement> = React.useCallback(
    event => {
      event.stopPropagation();
      onClose();
    },
    [onClose],
  );

  return (
    <div className={classNames(styles['base'], styles[placement])}>
      <div className={classNames(styles['triangle'], styles[placement])} />
      <div
        className={styles['close']}
        onClick={handleCloseButtonClick}
        onMouseEnter={handleMouseEnterInCloseButton}
        onMouseLeave={handleMouseLeaveCloseButton}
        aria-label="Закрыть"
        role="button"
      >
        <IconClose12 color={closeButtonColor} />
      </div>
      <div className={styles['content']}>{content}</div>
    </div>
  );
};
